import AppointmentAttendanceCard from './AppointmentAttendanceCard';

export default AppointmentAttendanceCard;
